<template>
  <div class="ingredient-card-popover">
    <div class="flex justify-between w-full">
      <slot name="items" />
    </div>
    <slot />
  </div>
</template>

<style>
@reference '@/css/index.css';

.ingredient-card-popover {
  @apply w-[634px] h-[318px] overflow-hidden shrink-0 bg-neutral-50 border-[1.5px] border-neutral-300 rounded-3xl shadow-ingredient-popover py-7 pl-10 flex transition-all duration-1000;
}

.ingredient-popover-enter-active,
.ingredient-popover-leave-active {
  @apply duration-350;
}

.ingredient-popover-enter-active > * {
  @apply transition-all duration-200;
}

.ingredient-popover-leave-active > * {
  transition: translate 350ms ease-in-out, opacity 175ms ease-in-out 175ms;
}

.ingredient-popover-enter-from > *,
.ingredient-popover-leave-to > * {
  @apply translate-x-32 opacity-0;
}
</style>
